import React from "react";
import "./radio.scss";
import { Icons } from "../Icons";
import { Col, Row } from "react-bootstrap";
export const RadioButton = ({ updateTask, actualItem }) => {
  const isCompleted = actualItem.status === "NOT_STARTED" ? false : true;
  return (
    <Row
      className="radio-button"
      onClick={() => {
        updateTask(actualItem);
      }}
    >
      <Col xs={2} sm={2} md={2} lg={2} className="radio-button-wrapper">
        <span
          className={
            isCompleted
              ? `radio-circle radio-circle-visibility`
              : "radio-circle"
          }
        ></span>
        {isCompleted ? (
          <Icons
            iconname="form-fields-success-tick"
            variant="icon-sixteen-px"
          />
        ) : (
          ""
        )}
      </Col>
      <Col xs={10} sm={10} md={10} lg={10} className="goal-text-wrapper">
        <span className="goal-text">{actualItem.title}</span>
      </Col>
    </Row>
  );
};
